import './burns/style';
import FormStructure from './burns/form_structure';

export default FormStructure;